import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import "../0.styles.css";
import { Typography } from "@mui/material";
import { addEspaceCharacters, instance } from "../Components/config";
import { useAuth } from "../Components/AuthContext";
import { DialogAlert } from "../Components/DialogAlert";
import { useNavigate } from "react-router-dom";
import { LoaderBox } from "../Components/LoaderBox";

function ProductoAgregar() {
  const [dialog, setDialog] = React.useState({
    title: "",
    text: "",
    redirect: false,
    page: "/Productos",
  });
  const [openDialog, setOpenDialog] = React.useState(false);
  const navigate = useNavigate();
  const { user } = useAuth();
  const handleSubmit = (e) => {
    e.preventDefault();
    const info = e.target;
    instance
      .post("/catalogo/", {
        id: user.id,
        nombre: addEspaceCharacters(info.nombre.value),
        descripcion: addEspaceCharacters(info.descripcion.value),
      })
      .then((res) => {
        setDialog({
          title: "Operación exitosa",
          text: "El catálogo ha sido creado exitosamente.",
          redirect: true,
          page: "/Productos",
        });
      })
      .catch((err) => {
        if (err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response.data.message });
        }
      })
      .finally(setOpenDialog(true));
  };

  return (
    <LoaderBox>
      <Container
        component="main"
        maxWidth="xs"
        className="bordered-box"
        sx={{
          padding: "4px",
          marginTop: 8,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginTop: 4,
            marginBottom: 4,
          }}
        >
          <Typography component="h1" variant="h5">
            Nuevo catálogo
          </Typography>
          <Box
            component="form"
            sx={{
              mt: 1,
              display: "flex",
              flexDirection: "column",
              gap: "12px",
              width: "100%",
            }}
            onSubmit={handleSubmit}
          >
            <TextField
              margin="normal"
              label="Nombre"
              id="nombre"
              name="nombre"
              autoFocus
              required
              fullWidth
              inputProps={{ maxLength: 100 }}
            />
            <TextField
              name="descripcion"
              id="descripcion"
              label="Descripción"
              multiline
              required
              fullWidth
              inputProps={{ maxLength: 250 }}
            />
            <Box
              sx={{ width: "100%", display: "flex", justifyContent: "center" }}
            >
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ width: { xs: "100%", sm: "50%" } }}
              >
                Agregar
              </Button>
            </Box>
          </Box>
        </Box>
      </Container>
      <DialogAlert
        title={dialog.title}
        text={dialog.text}
        open={openDialog}
        setOpen={setOpenDialog}
        redirectOnClose={dialog.redirect}
        page={dialog.page}
      />
    </LoaderBox>
  );
}

export { ProductoAgregar };
